import { render, staticRenderFns } from "./AccountAlreadyExists.vue?vue&type=template&id=bca80ad2&scoped=true&"
import script from "./AccountAlreadyExists.vue?vue&type=script&lang=js&"
export * from "./AccountAlreadyExists.vue?vue&type=script&lang=js&"
import style0 from "./AccountAlreadyExists.vue?vue&type=style&index=0&id=bca80ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca80ad2",
  null
  
)

export default component.exports